import React from "react"
import Contact from "@components/Contact";

const ContactsGroup = (linkedItem) => {
  const contactGroup = linkedItem.linkedItem.elements;
  const linkedContacts = contactGroup.contacts.value;
  
  return ( 
  <div>
    <li className="staff-group--item list-none m-0 mb-10 border-0 p-0">
    <h4 className="text-[#767676] text-[24px] leading-[36px] mb-8">{contactGroup.title && contactGroup.title.value}</h4>
    <ul className="staff-group--sublist !pl-0 grid grid-cols-12 gap-8 justify-between !list-none">
    {linkedContacts && linkedContacts.map((item, i) => {
       return <Contact linkedItem={item} />
    })}
    </ul>
  </li>
  </div>
  )
}

export default ContactsGroup